import { Injectable } from '@angular/core';

@Injectable()
export class I18nService {
	public language = 'es';
}
